<template>
	<div class="d-flex flex-column flex h100">
		<navbar></navbar>
		<div class="app">
			<config-sidenav></config-sidenav>
			<div id="content" class="app-content box-shadow-3">
				<div id="navbar" class="navbar navbar-expand-lg">
					<!-- Page title -->
					<loading type="header" v-if="assessment.loaded == 0" />
					<div v-if="assessment.loaded != 0" class="navbar-text nav-title flex" id="pageTitle">
						{{ assessment.name }}
					</div>
				</div>

				<div class="content-main" style="background-color:white">
					<!-- Page content goes here -->
					<div class="h-100" v-if="assessment.loaded != 0">
						<div class="row">
							<div class="col-md-6">
								<div class="tab-content">
									<!-- Item Details -->
									<assessment-assign
										id="tab-2"
										:assessment="assessment"
										:valid="valid"
										:defaultTab="tab == 1"
										:user="user"
										@assigned="forceRerender"
									></assessment-assign>
								</div>
							</div>
							<div class="col-md-6">
								<assessment-stat
									v-if="renderComponent"
									id="tab-2"
									:assessment="assessment"
									:valid="valid"
									:defaultTab="tab == 1"
									:user="user"
								></assessment-stat>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<mzfooter></mzfooter>
	</div>
</template>

<style scoped>
.margin-overlap {
	margin-right: -2.5rem;
}
</style>

<script>
import moment from "moment";

import EditPane from "@/components/EditPane";
import SaveOptionalModal from "@/components/SaveOptionalModal";
import ConfigSelect from "@/components/ConfigSelect";
import RichText from "@/components/RichText";
import AssessmentEditDetails from "@/components/assessment/AssessmentEditDetails";
import AssessmentAssign from "@/components/assessment/AssessmentAssign";
import AssessmentStat from "@/components/assessment/AssessmentStat";

import AssessmentService from "@/services/AssessmentService";
import ContentAreaService from "@/services/ContentAreaService";
import GradeService from "@/services/GradeService";
import ValidationService from "@/services/ValidationService";
import Notie from "@/services/NotieService";
import fs from "@/services/FormatService";
import BB from "bluebird";
import Utils from "@/services/Utils";
import draggable from "vuedraggable";
import ConfigItemSearch from "@/components/ConfigItemSearch";

export default {
  name: "AssessmentEdit",

  props: ["user", "params", "query"],

  components: {
    "assessment-edit-details": AssessmentEditDetails,
    "assessment-assign": AssessmentAssign,
    "assessment-stat": AssessmentStat,
    EditPane,
    SaveOptionalModal,
    ConfigSelect,
    ConfigItemSearch,
    RichText,
    draggable
  },

  data() {
    return {
      fs: fs,
      assessment: {
        loaded: 0
      },
      tab: 1,
      assesmentstat: [],
      contentAreas: [],
      selectedContentArea: null,
      selectedItem: null,
      originalDesc: "",
      refresh: null,

      grades: [],
      sGrades: null,

      dirty: false,
      valid: {},
      saveOptModal: false,
      saveOptNext: () => {},
      saveOptCancel: () => {},
      renderComponent: true
    };
  },

  computed: {
    sGradeIDs() {
      return _.map(this.sGrades, "id");
    }
  },

  created() {
    this.loadData();
    this.initValidation();

    if (this.query.tab) {
      this.tab = this.query.tab;
    }
  },

  watch: {
    sGradeIDs(newVal) {
      let oldVal = this.assessment.grade_ids;
      if (oldVal == null) {
        oldVal = newVal.slice(0, newVal.length - 1);
      }
      let same = true;
      if (newVal.length == oldVal.length) {
        for (let i = 0; i < newVal.length; i++) {
          if (newVal[i] != oldVal[i]) {
            same = false;
          }
        }
      } else {
        same = false;
      }

      if (!same) {
        this.assessment.grade_ids = newVal;
      }
    }
  },
  format(date) {
    return moment(date).format("M/D/YY h:mm:ss a");
  },
  beforeRouteLeave(to, from, next) {
    if (this.dirty) {
      this.saveOptNext = () => {
        next();
      };
      this.saveOptCancel = () => {
        next(false);
      };
      this.saveOptModal = true;
    } else {
      next();
    }
  },

  methods: {
    initValidation() {
      this.valid = ValidationService.newValidator({
        name: {
          group: "details",
          errorMsg: "You must assign a name",
          func: () => {
            return (
              this.assessment &&
              this.assessment.name &&
              this.assessment.name != ""
            );
          }
        },
        ref: {
          group: "details",
          errorMsg: "You must assign a reference ID",
          func: () => {
            return (
              this.assessment &&
              this.assessment.ref_id &&
              this.assessment.ref_id != ""
            );
          }
        },
        ref_char: {
          group: "details",
          errorMsg:
            "Reference IDs may not contain spaces or any of the following characters: ! # % ^ * ( )  / [ ] { } < > ? | ' \" :",
          func: () => {
            return (
              this.assessment &&
              this.assessment.ref_id &&
              fs.isGoodRefID(this.assessment.ref_id)
            );
          }
        }
      });
    },
    forceRerender() {
      // Remove my-component from the DOM

      this.renderComponent = false;
      this.$nextTick(() => {
        // Add the component back in
        this.renderComponent = true;
      });
    },
    blankAssessment() {
      return {
        loaded: 0
      };
    },

    watchChanges() {
      if (this.unwatch) {
        this.unwatch();
      }
      this.unwatch = this.$watch(
        "assessment",
        (newc, old) => {
          this.dirty = true;
        },
        { deep: true }
      );
    },

    loadData() {
      this.dirty = false;
      var loaded = this.assessment.loaded;
      loaded++;

      if (this.params.id != "new") {
        return BB.props({
          assessment: AssessmentService.getAssessment(this.params.id),
          contentAreas: ContentAreaService.listContentAreas(),
          grades: GradeService.listGrades()
        })
          .then(resps => {
            this.assesmentstat = AssessmentService.getAssessmentStat(
              this.params.id
            );
            console.log(this.assesmentstat);
            this.assessment = resps.assessment.data;
            this.assessment.loaded = loaded;

            this.originalDesc = this.assessment.description;
            this.refresh = new Date();

            this.contentAreas = resps.contentAreas.data.content_areas;
            this.selectedContentArea = _.find(this.contentAreas, {
              id: this.assessment.content_area_id
            });
            this.updateContentAreaID(this.selectedContentArea);

            this.sGrades = [];
            this.grades = resps.grades.data;
            if (this.grades && this.grades.length > 0 && this.assessment) {
              _.each(this.assessment.grade_ids, gid => {
                let grade = _.find(this.grades, {
                  id: gid
                });
                if (grade) {
                  this.sGrades.push(grade);
                }
              });
            }

            this.watchChanges();
          })
          .catch(err => {
            console.log(err);
            Notie.error("Assessment not found, adding new assessment instead");
            this.$router.replace("/assessments/new");
          });
      } else {
        ContentAreaService.listContentAreas()
          .then(resp => {
            this.contentAreas = resp.data.content_areas;
            this.selectedContentArea = this.contentAreas[0];

            this.assessment = this.blankAssessment();
            this.assessment.loaded = loaded;
            this.$set(this.assessment, "name", "New Assessment");
            this.$set(this.assessment, "ref_id", "new_assessment");

            this.assessment.assessment_items = [];

            this.updateContentAreaID(this.selectedContentArea);
            this.watchChanges();
          })
          .catch(err => {
            Notie.error("Failed to load content areas");
          });
        GradeService.listGrades()
          .then(resp => {
            this.grades = resp.data;
          })
          .catch(err => {
            Notie.error("Failed to load grades");
          });
      }
    },

    updateContentAreaID(contentArea) {
      this.assessment.content_area_id = (contentArea && contentArea.id) || "";
    },

    saveAssessment() {
      return AssessmentService.saveAssessment(this.assessment)
        .then(resp => {
          Notie.info("Assessment Saved");
          if (this.assessment.id != resp.data.id) {
            this.$router.replace("/assessments/" + resp.data.id);
          }
          this.loadData();
        })
        .catch(err => {
          console.log(err);
          Notie.error("Failed to save assessment", err);
        });
    },

    addItem() {
      this.assessment.assessment_items.push({
        sequence: this.assessment.assessment_items.length + 1,
        item_id: this.selectedItem.id,
        item: this.selectedItem
      });
      this.dirty = true;
    },

    itemsSorted() {
      var seq = 1;
      _.each(this.assessment.assessment_items, ai => {
        ai.sequence = seq;
        seq++;
      });
    },

    canSave() {
      return this.dirty;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/vues/SetupConfig/AssessmentAssign.vue